// extracted by mini-css-extract-plugin
export default {"container":"VendorItems_container__GzFdm","topRow":"VendorItems_topRow__GEql5","title":"VendorItems_title__EZlAr","listContainer":"VendorItems_listContainer__X6iQ5"};